/* eslint-disable no-shadow */
import React, { useCallback, useState } from "react";

import { makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import moment from "moment";

import { setNotificationMessage } from "../../../../redux/actions/notificationAction";
import {
  BarLoader, RangePicker, Button, ExportButton,
} from "../../../../shared/widgets";
import { PageWrapper } from "../../../../shared/layout";
import ExpenseModal from "./ExpenseModal";
import ExpenseList from "./ExpenseList";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { newReconDownloadExcelAPI } from "../../../../services/APIutils";
import { saveExcelBlob } from "../../../../shared/methods/sharedMethods";
import { MessageType, NEW_BASE_URL } from "../../../../Constant";
import UploadExcelModal from "../../../../shared/components/fileupload/UploadExcelModal";

const useStyles = makeStyles(() => ({
  headerItem: {
    margin: "0 1vh",
  },
  "@media (max-width:576px)": {
    customPageWrapper: {
      "& .page-header": {
        flexWrap: "wrap",
        paddingLeft: 0,
        "& .page-header-title": {
          fontSize: "25px",
        },
      },
    },
    headerItem: {
      margin: "1vh 1vh 0 0",
      "& .DateRangePicker": {
        marginLeft: "0",
      },
    },
    headerWrapper: {
      width: "100%",
      flexWrap: "wrap",
    },
  },
}));

function ExpenseView(props) {
  const {
    selectedDateFilter: selectedDateFilterProps, initiateNotification,
    selectDateFilter: selectDateFilterProp, refreshUpliftStatus,
  } = props;
  const classes = useStyles();

  // let [searchString, setSearchString] = useState('');
  const [selectedDateFilter, setSelectedDateFilter] = useState({
    fromDate: moment(selectedDateFilterProps.fromDate).format("YYYY-MM-DD").toString() || moment().startOf("month").format("YYYY-MM-DD").toString(),
    toDate: moment(selectedDateFilterProps.toDate).format("YYYY-MM-DD").toString() || moment().format("YYYY-MM-DD").toString(),
  });
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [openUploadXlsxModal, setOpenUploadXlsxModal] = useState(false);
  // let handleSearchChange = (e) => {
  //   setSearchString(e);
  // };
  const viewUploadXlsxModal = useCallback(() => {
    setOpenUploadXlsxModal(true);
  }, []);

  const displayUploadXlsxModal = () => (
    <UploadExcelModal
      showModal={openUploadXlsxModal}
      isUploadDisabled={false}
      messageCallBack={(type) => {
        // if (type === MessageType.SUCCESS) {
        //   this.getSettlementDistanceStatus();
        // }
        if (
          type === MessageType.SUCCESS
            || !(type && type === MessageType.ERROR)
        ) {
          setOpenUploadXlsxModal(false);
        }
      }}
      uploadType="expense"
    />
  );

  const endpoint = "expense/exportExpense";
  const exportExpenseQuery = {
    platform: "web",
    timezoneOffset: -330,
    addOnFilter: {
      cityIdArr: props?.cityFilter || [],
      operatorIdArr: props?.operatorFilter || [],
      fromDate: selectedDateFilter?.fromDate || "",
      toDate: selectedDateFilter?.toDate || "",
    },
  };

  const downloadSampleExcel = async () => {
    const url = `${NEW_BASE_URL}/v1/expense/sampleExpenseUploadSheet`;
    await newReconDownloadExcelAPI(url, {})
      .then((res) => {
        let fileName = res.headers["content-disposition"].split("Filename=")[1];
        fileName = fileName.replaceAll("\"", "");
        saveExcelBlob({ blob: res.data, fileName });
      })
      .catch((err) => {
        initiateNotification({
          type: MessageType.ERROR,
          message: err.message,
        });
      });
  };

  const handleDatesChange = (dates) => {
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      setSelectedDateFilter({
        fromDate: moment(fromDate).format("YYYY-MM-DD").toString(),
        toDate: moment(toDate).format("YYYY-MM-DD").toString(),
      });
      selectDateFilterProp({ fromDate, toDate });
    }
  };

  const toggleModal = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <div>
      <PageWrapper customClass={classes.customPageWrapper}>
        <PageWrapper.Header heading="Expenses" hideS>
          <div className={`flex pull-right ${classes.headerWrapper} `}>
            {/* <div className={classes.headerItem}>
              <SearchBar
                placeHolder={'Search for city or operator'}
                onSearchChange={(e) => {
                  handleSearchChange(e);
                }}
              />
            </div> */}
            <div className={classes.headerItem}>
              <RangePicker
                startDate={moment(new Date(selectedDateFilter?.fromDate))}
                endDate={moment(new Date(selectedDateFilter?.toDate))}
                monthsToDisplay={1}
                onDatesChange={handleDatesChange}
              />
            </div>
            <div className={classes.headerItem}>
              <ExportButton
                query={exportExpenseQuery}
                endpoint={endpoint}
                pageName="Expenses"
                isDisable={refreshUpliftStatus === "Data Sync In Process"}
              />
            </div>
            <div
              role="link"
              className="xlsx-wrapper cursor-pointer"
              onClick={downloadSampleExcel}
              onKeyDown={() => { /* onKeyDown */ }}
              tabIndex="0"
            >
              Sample File
            </div>
            <div className={classes.headerItem}>
              <Button onClick={viewUploadXlsxModal} buttonText="Upload" />
            </div>
            <div className={classes.headerItem}>
              <Button onClick={toggleModal} buttonText="New Expense" />
            </div>
          </div>
        </PageWrapper.Header>
        <PageWrapper.Body>
          <BarLoader scope="header" />
          <ExpenseList
          // searchString={searchString}
            refresh={refresh}
            setRefresh={setRefresh}
            selectedDateFilter={selectedDateFilter}
            testDate={props?.testDate}
          />
          {open && (
            <ExpenseModal
              open={open}
              setOpen={setOpen}
              setRefresh={setRefresh}
              testDate={props?.testDate}
            />
          )}
          {openUploadXlsxModal && displayUploadXlsxModal()}
        </PageWrapper.Body>
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    refreshUpliftStatus:
      state && state.Contracts && state.Contracts.refreshUpliftStatus,
  };
}

const mapDispatchToProps = (dispatch) => ({
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseView);
